export default __webpack_public_path__ + "static/media/nooria.ee52bc38.png";